/**
 * 格式化信息流数据
 */

//  我的自选股
const formatMystockData = data => {
    if (data.length > 0) {
        data.map(item => [item.name, '0.11%', 1]);
    }

    return data;
};

//  每日提示 mrts
const formatMrtsData = data => {
    Object.keys(data).forEach(key => {
        if (key === 'mrgg') {
            data[key] = data[key].body.map(item => [
                {
                    name: item[4],
                    url: `http://app.finance.ifeng.com/data/stock/ggzw.php?id=${item[3]}&symbol=${item[1]}&ggtype=${
                        item[5]
                    }`,
                },
                {
                    name: item[2],
                    url: `http://finance.ifeng.com/app/hq/stock/${item[0]}/`,
                },
                item[6],
                item[7],
                {
                    name: '更多',
                    url: `http://app.finance.ifeng.com/data/stock/ggzw.php?id=${item[3]}&symbol=${item[1]}&ggtype=${
                        item[5]
                    }`,
                },
            ]);
        } else if (key === 'ipo') {
            data[key] = data[key].body.map(item => [
                {
                    name: item[1],
                    url: `http://app.finance.ifeng.com/data/stock/tab_fxjg.php?symbol=${item[1]}`,
                },
                {
                    name: item[item.length - 1] === 'kcb' ? `科?${item[2]}` : item[2],
                    url: `http://app.finance.ifeng.com/data/stock/tab_fxjg.php?symbol=${item[1]}`,
                },
                // item[1],

                ...item.slice(3, item.length - 1),
            ]);
        } else if (key === 'suspend') {
            data[key] = data[key].body.map(item => [
                {
                    name: item[1],
                    url: `http://finance.ifeng.com/app/hq/stock/${item[0]}/`,
                },
                {
                    name: item[2],
                    url: `http://app.finance.ifeng.com/data/stock/tab_fxjg.php?symbol=${item[1]}`,
                },
                item[3],
                ...item.slice(5),
            ]);
        } else {
            data[key] = data[key].body.map(item => [
                {
                    name: item[1],
                    url: `http://finance.ifeng.com/app/hq/stock/${item[0]}/`,
                },
                {
                    name: item[2],
                    url: `http://app.finance.ifeng.com/data/stock/tab_fxjg.php?symbol=${item[1]}`,
                },
                ...item.slice(3),
            ]);
        }
    });

    return data;
};

//  沪深两市涨跌榜 rank
const formatRankData = data => {
    Object.keys(data).forEach(key => {
        Object.keys(data[key].data).forEach(_key => {
            const _data = data[key].data[_key].body.slice(0, 5);

            data[key].data[_key] = _data.map(item => [
                {
                    name: item[1],
                    url: `http://finance.ifeng.com/app/hq/stock/${item[0]}/`,
                },
                ...item.slice(2),
            ]);
        });
        data[key] = data[key].data;
    });

    return data;
};

//  行业概念涨跌榜 hygn
const formatHygnData = data => {
    Object.keys(data).forEach(key => {
        Object.keys(data[key].body).forEach(_key => {
            data[key].body[_key] = {
                name: data[key].body[_key].name,
                data: data[key].body[_key].codeinfo.slice(0, 5).map(item => [
                    {
                        name: item[1],
                        url: `http://finance.ifeng.com/app/hq/stock/${item[0]}/`,
                    },
                    ...item.slice(2),
                ]),
            };
        });
        data[key] = data[key].body;
    });

    return data;
};

//  市场异动监控 ydjk
const formatYdjkData = (state, data) => {
    Object.keys(data).forEach(key => {
        data[key] = data[key].body.slice(0, 5).map(item => [
            {
                name: item[1],
                url:
                    key === 'ddzz'
                        ? `http://app.finance.ifeng.com/hq/stock_bill.php?code=${item[0]}`
                        : `http://finance.ifeng.com/app/hq/stock/${item[0]}/`,
            },
            ...item.slice(2),
        ]);
    });

    const _data = [
        [data.scld, data.ddzz],
        [data.wbup, data.wbdown],
        [data.zf, data.volrate],
        [data.amo, data.turnover],
    ];

    const _tables = state.tables.map((item, index) => ({
        ...item,
        data: _data[index],
    }));

    state = {
        ...state,
        tables: _tables,
    };

    return state;
};

//  主力动态 zldt
const formatZldtData = data => {
    Object.keys(data).forEach(key => {
        const _url = item => {
            if (key === 'zjlchy' || key === 'zjlrhy') {
                return `http://app.finance.ifeng.com/list/stock_cate.php?c=${item[0].slice(
                    3,
                    item[0].length,
                )}&s=999&level=2&cname=${encodeURIComponent(item[1])}`;
            } else {
                return `http://finance.ifeng.com/app/hq/stock/${item[0]}/`;
            }
        };

        data[key] = data[key].body.slice(0, 5).map(item => [
            {
                name: item[1],
                url: _url(item),
            },
            ...item.slice(2),
        ]);
    });

    return data;
};

//  龙虎榜 lhb
const formatLhbData = data => {
    Object.keys(data).forEach(key => {
        data[key] = {
            date: data[key].date,
            data: data[key].body.map(item => ({
                name: item[2],
                url: `http://lhb.finance.ifeng.com/detail.php?code=${item[1]}`,
                num: item[3],
            })),
        };
    });

    return data;
};

export {
    formatMystockData,
    formatMrtsData,
    formatRankData,
    formatHygnData,
    formatYdjkData,
    formatZldtData,
    formatLhbData,
};
